<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addClassHourDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <!--课时类型-->
        <el-form-item prop="coursePackageId" label="课包类型">
          <el-select
            :disabled="this.addClassHourDialog.type === 'edit'"
            v-model="form.coursePackageId"
            placeholder="请选择课时类型"
            @change="classTypeChange"
          >
            <el-option
              v-for="item in this.coursePackageList.coursePackageList"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="activeName"
          label="活动名称"
        >
          <el-input
            type="text"
            placeholder="请输入活动名称"
            v-model="form.activeName"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="classHour"
          label="课时数"
        >
          <el-input
            type="text"
            placeholder="请输入课时数"
            v-model="form.classHour"
          ></el-input>
        </el-form-item>
        <el-form-item prop="buyTime" label="课包购买日期">
          <el-date-picker
            v-model="form.buyTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="monthNum" label="有效月数">
          <el-input
            type="text"
            placeholder="请输入有效月数"
            v-model="form.monthNum"
          ></el-input>
        </el-form-item>
        <el-form-item prop="beginTime" label="课包开启日期"  v-if="addClassHourDialog.type === 'edit'">
          <el-date-picker
            v-model="form.beginTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item required prop="classHoursDDL" label="课包截止日期" v-if="addClassHourDialog.type === 'edit'">
          <el-date-picker
            v-model="form.classHoursDDL"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="isUse" label="是否过期:">
          <el-select v-model="form.isUse" placeholder="是否过期">
            <el-option
              v-for="item in memberStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isActive" label="是否激活:">
          <el-select v-model="form.isActive" placeholder="是否激活">
            <el-option
              v-for="item in isActive"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="notes" label="备注">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            v-model="form.notes"
          ></el-input>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  addCoursePackageAndMember,
  editCoursePackageAndMember,
} from "@/api/memberCoursePackage";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  name: "addFundDialogs",
  data() {
    let validateClassHour = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("课时增加/减少不能为空"));
      } else {
        var reg = /^\+|-/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的格式(+1|-1)"));
        } else {
          callback();
        }
      }
    };
    return {
      isVisible: this.isShow,
      selectDisabled: false,
      form: {
        activeName: "",
        id: "",
        userName: "",
        classHour: "",
        classHoursDDL: "",
        monthNum: "",
        coursePackageId: "",
        beginTime: "",
        notes: "",
        isUse: "",
        isActive: "",
        buyTime: "",
      },
      classHourType: [
        { label: "通用课时", value: "0" },
        { label: "启蒙课时", value: "1" },
      ],
      memberStatus: [
        { label: "未过期", value: true },
        { label: "已过期", value: false },
      ],
      isActive: [
        { label: "已激活", value: 1 },
        { label: "未激活", value: 0 },
      ],
      form_rules: {
        type: [
          { required: true, message: "自定义条目不能为空", trigger: "blur" },
        ],
        classhourType: [
          { required: true, message: "课时类型不能为空", trigger: "blur" },
        ],
        classhours: [
          { required: true, message: "课时增加/减少不能为空", trigger: "blur" },
          { validator: validateClassHour },
        ],
        opreateDate: [
          { required: true, message: "日期不能为空", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    username: String,
    name: String,
    coursePackageList: Object,
    formatCoursePackageList: Object,
  },
  computed: {
    ...mapGetters(["addClassHourDialog"]),
  },
  created() {},
  mounted() {
    console.log("添加页面");
    console.log(this.username);
    console.log(this.coursePackageList);
    console.log(this.formatCoursePackageList);
    if (this.addClassHourDialog.type === "edit") {
      console.log(this.dialogRow);
      this.form = this.dialogRow;
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          para.userName = this.username;
          console.log(para);
          let coursePackageName = this.formatCoursePackageList
            .formatCoursePackageList[parseInt(formData.coursePackageId)];
          // edit
          if (this.addClassHourDialog.type === "edit") {
            editCoursePackageAndMember(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "修改(" +
                    this.name +
                    ")会员课包操作,课包类型为:" +
                    coursePackageName +
                    ",课包购买时间为:" +
                    formData.buyTime,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getClassHourList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addCoursePackageAndMember(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                // console.log(parseInt(formData.coursePackageId));
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "添加(" +
                    this.name +
                    ")会员课包操作,课包类型为:" +
                    coursePackageName +
                    ",课包购买时间为:" +
                    formData.buyTime,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getClassHourList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
    classTypeChange(e) {
      let hasVal = this.coursePackageList.coursePackageList.find(item => {
        return item.value === e
      })
      console.log(hasVal);
      if(hasVal !== undefined) {
        this.form.classHour = hasVal.classHour
      }
    }
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
